import { render } from "./Tenders.vue?vue&type=template&id=04366176"
import script from "./Tenders.vue?vue&type=script&lang=js"
export * from "./Tenders.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Tenders/Tenders.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "04366176"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('04366176', __exports__)) {
    api.reload('04366176', __exports__)
  }
  
  module.hot.accept("./Tenders.vue?vue&type=template&id=04366176", () => {
    api.rerender('04366176', render)
  })

}


export default __exports__